import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
} from '@angular/router';

/**
 * Extends the default strategy so that routes marked with
 * `data: { forceReload: true }` are never reused —
 * Angular will destroy and recreate the component on every navigation.
 */
export class ForceReloadRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    if (future.data['forceReload'] || curr.data['forceReload']) {
      return false;
    }
    return super.shouldReuseRoute(future, curr);
  }
}
